import React from 'react';
import * as styles from './styles.scss';

const ButtonTop = ({ className, children, ...props }) => (
  <button
      className={`${styles.top}${className ? ` ${className}` : ''}`}
      {...props}
  >
      {children}
  </button>
);

export default ButtonTop;
